import BusinessUnitsAPI from '../../../api/BusinessUnitsAPI';
import BusinessUnit from '../../../models/businessUnit/BusinessUnit';
import AssetAPI from "../../../api/AssetAPI";

export default {
  async loadAllBusinessUnits({
    commit
  }) {
    const response = await new BusinessUnitsAPI().all();
    const result = [];
    for (let i = 0; i < response.length; i++) {
      result.push(BusinessUnit.createFromData(response[i]))
    }
    commit('SET_ALL_BUSINESS_UNITS', result);
  },
  async createBusinessUnit({commit}, data) {
    const dataObj = {
      name: data[0],
      externalId: data[1],
    };
    const response = await new BusinessUnitsAPI().createBusinessUnit(dataObj);
    commit('ADD_NEW_BUSINESS_UNIT', response);
    return response;
  },
  async updateBusinessUnit({ commit }, businessUnitData) {
    const response = await new BusinessUnitsAPI().editBusinessUnit(businessUnitData);
    const updatedBusinessUnit = BusinessUnit.createFromData(response); // Преобразуем ответ API
    commit('UPDATE_BUSINESS_UNIT', updatedBusinessUnit);
    return updatedBusinessUnit;
  },
};
